<template>
  <div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-12 d-flex justify-content-between align-items-center">
    <div class="d-flex align-items-center">
      <h2 class="mb-0">{{$t("navigations.manage Shells") }}</h2>
      <button
        v-if="!showLoading"
        class="badge-btn ms-3"
        :class="shellLevel === 'program' ? 'badge-program' : (shellLevel === 'report' ? 'badge-report' : 'badge-study')"
      >
        <span class="dot-wrap">
          <span class="badge-dot-pulse"></span>
          <span class="badge-dot"></span>
        </span>
        {{ shellLevel === 'program' ? 'Program Level Shell' : (shellLevel === 'report' ? 'Report Level Shell' : 'Study Level Shell')}}
      </button>
    </div>
    <div class="position-relative align-self-center" aria-label="Close" tabindex="0">
    <i class="fa fa-times cursor-pointer"    
    src="../../assets/img/create.png"
    width="17"
    height="17"
    alt="Close" @click="shellpageclose()"></i>
    <div class="tool-tip mt-3">{{ $t("navigations.close") }}</div>
    </div>
  </div>
</div>

  <div class="wrapper wrapper-content px-0">
    <div class="ibox">

      <div class="row">
        <!-- <div class=col-lg-1></div> -->

        <!-- LEFT SIDE -->
        <div class="col-lg-6 pr-1">
          <div class="card p-2 mb-2 left-scroll">
            <form autocomplete="off" @submit.prevent>
            <h5 class="mb-2">{{$t("navigations.Edit Shell Template") }}</h5>

            <!-- Version Badge -->
            <div class="versioncard mb-2 border p-1 border-left-blue">
              <span class="badge bg-primary">Version: {{ version || '1.0' }}</span>
              <span class="badge ms-1"  style="background-color: green;" v-if="isDefault" >DEFAULT</span>
            </div>

            <!-- SHELL DETAILS -->
            <div class="section-card">
              <div class="section-heading">
                <i class="fa fa-file-code-o section-heading-icon"></i>
                <div class="section-title">SHELL DETAILS</div>
              </div>
              <div class="row g-2">
                <div class="col-lg-6">
                  <label class="form-label-sm">Shell Name</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    :class="{ 'is-invalid': shellNameError }"
                    placeholder="Enter shell name"
                    v-model="shellName"
                    name="shell_name_nofill"
                    autocomplete="new-password"
                  />
                  <div class="invalid-feedback" v-if="shellNameError">{{ shellNameError }}</div>
                </div>
                <div class="col-lg-6">
                  <label class="form-label-sm">Version</label>
                  <input type="text" class="form-control form-control-sm" v-model="version" name="shell_version_nofill" autocomplete="new-password" />
                </div>
              </div>
            </div>

            <!-- PROGRAM CONFIGURATION -->
            <div class="section-card" v-if="programId">
              <div class="section-heading">
                <i class="fa fa-cogs section-heading-icon"></i>
                <div class="section-title">PROGRAM CONFIGURATION</div>
              </div>
              <div class="row g-2">

                <!-- Column Filters (Multiselect) -->
                <div class="col-lg-6">
                  <label class="form-label-sm">
                    Column Filters
                    <sup><i class="fa fa-asterisk required"></i></sup>
                  </label>
                  <Multiselect
                    id="columnFilters"
                    valueProp="value"
                    v-model="columnFieldNames"
                    mode="multiple"
                    :options="columnFiltersValues"
                    :searchable="true"
                    :hideSelected="false"
                    :closeOnSelect="false"
                    class="multiselect-theme form-control-sm"
                  />
                </div>

                <!-- Group By (only show if reportType === 'Table') -->
                <div class="col-lg-6" v-if="reportType === 'Table'">
                  <label class="form-label-sm">
                    Group By
                    <sup><i class="fa fa-asterisk required"></i></sup>
                  </label>
                  <select class="form-select form-select-sm" v-model="groupByField">
                    <option value="">None</option>
                    <option v-for="field in groupByFilter" :key="field" :value="field">
                      {{ field }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <!-- FONT SETTINGS -->
            <div class="section-card">
              <div class="section-heading">
                <i class="fa fa-font section-heading-icon"></i>
                <div class="section-title">FONT SETTINGS</div>
              </div>
              <div class="row g-2">
                <div class="col-lg-6">
                  <label class="form-label-sm">Font Family</label>
                  <select class="form-select form-select-sm" v-model="fontFamily">
                    <option v-for="opt in fontFamilyOptions" :key="opt" :value="opt">{{ opt }}</option>
                  </select>
                </div>
                <div class="col-lg-6">
                  <label class="form-label-sm">Font Size (pt)</label>
                   <input type="number" class="form-control form-control-sm" v-model="fontSize" name="shell_fontsize_nofill" autocomplete="new-password" />
                </div>
              </div>
            </div>

            <!-- PAGE LAYOUT -->
            <div class="section-card">
              <div class="section-heading">
                <i class="fa fa-columns section-heading-icon"></i>
                <div class="section-title">PAGE LAYOUT- Margin (mm)</div>
              </div>
              <div class="row g-2">
                <!-- <div class="col-lg-6">
                  <label class="form-label-sm">Orientation</label>
                  <select class="form-select form-select-sm" v-model="orientation">
                    <option value="portrait">Portrait</option>
                    <option value="landscape">Landscape</option>
                  </select>
                </div> -->
                <!-- <div class="col-lg-6">
                  <label class="form-label-sm">Width (MM)</label>
                  <input type="number" class="form-control form-control-sm" v-model="widthMm" />
                </div> -->
                <!-- <div class="col-lg-6">
                  <label class="form-label-sm">Height (MM)</label>
                  <input type="number" class="form-control form-control-sm" v-model="heightMm" />
                </div> -->
                <div class="col-lg-3">
                  <label class="form-label-sm">Top</label>
                  <input type="number" class="form-control form-control-sm" v-model="marginTopMm" name="shell_mtop_nofill" autocomplete="new-password" />
                </div>
                <div class="col-lg-3">
                  <label class="form-label-sm">Bottom</label>
                  <input type="number" class="form-control form-control-sm" v-model="marginBottomMm" name="shell_mbot_nofill" autocomplete="new-password" />
                </div>
                <div class="col-lg-3">
                  <label class="form-label-sm">Left</label>
                  <input type="number" class="form-control form-control-sm" v-model="marginLeftMm" name="shell_mleft_nofill" autocomplete="new-password" />
                </div>
                <div class="col-lg-3">
                  <label class="form-label-sm">Right</label>
                  <input type="number" class="form-control form-control-sm" v-model="marginRightMm" name="shell_mright_nofill" autocomplete="new-password" />
                </div>
              </div>
            </div>

            <!-- HEADER / TITLE / FOOTER -->
            <div class="section-card">

              <!-- HEADER -->
              <div class="d-flex justify-content-between align-items-center mb-1">
                <div class="section-subheading">
                  <i class="fa fa-arrow-up section-heading-icon"></i>
                  <span id="header" class="fw-bold small">HEADER</span>
                </div>
                <div class="d-flex gap-1 align-items-center">
                  <label class="mb-0 me-1 small d-flex align-items-center gap-1">
                    <input type="checkbox" v-model="headerBorderBottom" /> Border Bottom
                  </label>
                  <div class="position-relative align-self-center" aria-label="Add Header Row" tabindex="0" >
                  <button class="btn btn-primary btn-xs cursor-pointer" src="../../assets/img/create.png"
                    width="17"
                    height="17"
                    alt="Add Row" @click="addHeaderRow" :disabled="headerRows.length >= maxHeaderRows">
                    <i class="fa fa-plus"></i>
                  </button>
                   <div class="tool-tip mt-2">Add Row</div>
                  </div>
                  <div class="position-relative align-self-center" aria-label="Remove Header Row" tabindex="0" >
                  <button class="btn btn-danger btn-xs cursor-pointer" src="../../assets/img/create.png"
                    width="17"
                    height="17"
                    alt="Add Row" @click="removeHeaderRow" :disabled="headerRows.length <= 1">
                    <i class="fa fa-minus"></i>
                  </button>
                  <div class="tool-tip mt-2">Remove Row</div>

                  </div>
                </div>
              </div>

              <div v-for="(row, index) in headerRows" :key="'header-' + index" class="row g-1 mb-1">
                <div class="col-lg-4">
                  <label class="form-label-sm">Left</label>
                  <select class="form-select form-select-sm" v-model="row.left">
                    <option value="">-- Select --</option>
                    <option v-for="opt in tokenOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                  </select>
                </div>
                <div class="col-lg-4">
                  <label class="form-label-sm">Center</label>
                  <select class="form-select form-select-sm" v-model="row.center">
                    <option value="">-- Select --</option>
                    <option v-for="opt in tokenOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                  </select>
                </div>
                <div class="col-lg-4">
                  <label class="form-label-sm">Right</label>
                  <select class="form-select form-select-sm" v-model="row.right">
                    <option value="">-- Select --</option>
                    <option v-for="opt in tokenOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                  </select>
                </div>
              </div>

              <hr class="my-2" />

              <!-- TITLE -->
              <div class="row mb-1 align-items-end">
                <div class="col-12 section-subheading mb-1">
                  <i class="fa fa-text-height section-heading-icon"></i>
                  <span class="fw-bold small">TITLE</span>
                </div>
                <div class="col-md-6 mt-1">
                  <select class="form-select form-select-sm w-100" v-model="titleText">
                    <option value="">-- Select Field --</option>
                    <option v-for="opt in titleTokenOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                  </select>
                </div>
                <div class="col-md-6 d-flex align-items-center gap-3 small pb-1" style="font-size:11px;">
                  <label class="mb-0 d-flex align-items-center gap-1"><input type="checkbox" v-model="titleBold" /> Bold</label>
                  <label class="mb-0 d-flex align-items-center gap-1"><input type="radio" name="align" value="left"   v-model="titleAlign" /> Left</label>
                  <label class="mb-0 d-flex align-items-center gap-1"><input type="radio" name="align" value="center" v-model="titleAlign" /> Center</label>
                  <label class="mb-0 d-flex align-items-center gap-1"><input type="radio" name="align" value="right"  v-model="titleAlign" /> Right</label>
                </div>
              </div>

              <hr class="my-2" />

              <!-- FOOTER -->
              <div class="d-flex justify-content-between align-items-center mb-1">
                <div class="section-subheading">
                  <i class="fa fa-arrow-down section-heading-icon"></i>
                  <span class="fw-bold small">FOOTER</span>
                </div>
                <div class="d-flex gap-1 align-items-center">
                  <label class="mb-0 me-1 small d-flex align-items-center gap-1">
                    <input type="checkbox" v-model="footerBorderTop" /> Border Top
                  </label>
                  <div class="position-relative align-self-center" aria-label="Add Footer Row" tabindex="0">
                  <button class="btn btn-primary btn-xs cursor-pointer" src="../../assets/img/create.png"
                    width="17"
                    height="17"
                    alt="Add Row" @click="addFooterRow" :disabled="footerRows.length >= maxFooterRows">
                    <i class="fa fa-plus"></i>
                     </button>
                    <div class="tool-tip mt-2">Add Row</div>
                  </div>
                  <div class="position-relative align-self-center" aria-label="Remove Footer Row" tabindex="0">
                  <button class="btn btn-danger btn-xs cursor-pointer" src="../../assets/img/create.png"
                    width="17"
                    height="17"
                    alt="Remove Row" @click="removeFooterRow" :disabled="footerRows.length <= 1">
                    <i class="fa fa-minus"></i>
                  </button>
                    <div class="tool-tip mt-2">Remove Row</div>
                  </div>
                </div>
              </div>

              <div v-for="(row, index) in footerRows" :key="'footer-' + index" class="row g-1 mb-1">
                <div class="col-lg-4  form-group mb-0">
                  <label class="form-label-sm">Left</label>
                  <select class="form-select form-select-sm" v-model="row.left">
                    <option value="">-- Select --</option>
                    <option v-for="opt in tokenOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                  </select>
                </div>
                 <div class="col-md-4 form-group mb-0">
                            <label class="form-label-sm">Center</label>
                            <select 
                                class="form-select form-select-sm" 
                                v-model="row.center"
                                :disabled="isFootnoteSelected(row)"
                                @change="handleFooterSelection(row, 'center')"
                            >
                                <option value="">-- Select Field --</option>
                                <option v-for="opt in tokenOptions" :key="opt.value" :value="opt.value">
                                {{ opt.label }}
                                </option>
                            </select>
                        </div>

                        <div class="col-md-4 form-group mb-0">
                            <label class="form-label-sm">Right</label>
                            <select 
                                class="form-select form-select-sm" 
                                v-model="row.right"
                                :disabled="isFootnoteSelected(row)"
                                @change="handleFooterSelection(row, 'right')"
                            >
                                <option value="">-- Select Field --</option>
                                <option v-for="opt in tokenOptions" :key="opt.value" :value="opt.value">
                                {{ opt.label }}
                                </option>
                            </select>
                        </div>
              </div>

              <hr class="my-2" />

              <!-- Save / Cancel -->
              <div class="d-flex justify-content-end gap-2 mt-3">
                <!-- Program-level: show New Program, Save Changes, Cancel -->
                <template v-if="programId">
                  <div class="w-100 d-flex justify-content-between">
                  <button class="btn btn-danger px-2 py-0 btn-sm" style="font-size: 13px;" @click="goToShells"
                  >Cancel <i class="fa fa-times ms-1"></i></button>
                  <div class="d-flex gap-2">
                  <button class="save_btn px-1 py-0 btn-sm" style="font-size: 13px;" @click="saveAsNewProgram">Save as New Program Level shell <i class="fa fa-plus-circle ms-1"></i></button>
                  <button class="btn btn-primary px-2 py-0 btn-sm" style="font-size: 13px;" @click="updateShell">Save Changes <i class="fa fa-save ms-1"></i></button>
                  </div>
                  </div>
                </template>

                <!-- Report-level (no program): show New Report, Save Changes, Cancel -->
                <template v-else-if="reportId">
                  <div class="w-100 d-flex justify-content-between">
                  <button class="btn btn-danger px-2 py-0 btn-sm" style="font-size: 13px;"  @click="goToShells">Cancel
                   <i class="fa fa-times ms-1"></i>
                  </button>
                  <div class="d-flex gap-2">
                  <button class="save_btn px-1 py-0 btn-sm" style="font-size: 13px;" @click="saveAsNewReport">Save as New Report Level shell
                  <i class="fa fa-plus-circle ms-1"></i>
                  </button>
                  <button class="btn btn-primary px-2 py-0 btn-sm" style="font-size: 13px;" @click="updateShell">Save Changes
                   <i class="fa fa-save ms-1"></i>
                  </button>
                 </div>
                 </div>
                </template>

                <!-- Study-level: only Save Changes + Cancel -->
                <template v-else>
                  <button class="btn btn-primary px-2 py-0 btn-sm" style="font-size: 13px;" @click="updateShell">Save Changes <i class="fa fa-save ms-1"></i></button>
                  <button class="btn btn-danger px-2 py-0 btn-sm" style="font-size: 13px;" @click="goToShells">Cancel <i class="fa fa-times ms-1"></i></button>
                </template>
              </div>

            </div>
            </form>
          </div>
        </div>

        <!-- RIGHT SIDE: Live Preview -->
        <div class="col-lg-6 pl-1">
          <div class="card p-1 preview-scroll" :style="{ fontFamily: fontFamily, fontSize: fontSize + 'pt' }">
            <div class="d-flex justify-content-between">
              <div><h5 class="mb-1 mt-1">Preview</h5></div>
              <!-- <div class="pb-1">
                <select v-model="selectoption" class="form-select select-wide">
                  <option value="figure">Figure</option>
                  <option value="table">Table</option>
                  <option value="listing">Listing</option>
                </select>
              </div> -->
            </div>
            <div class="preview-box p-3">

              <!-- Header Preview -->
              <div
                v-for="(row, i) in headerRows"
                :key="'prev-header-' + i"
                 class="d-flex justify-content-between pb-1 mb-1"
                :class="{ 'border-bottom': headerBorderBottom }"
              >
                <span>{{ getTokenLabel(row.left) }}</span>
                <span>{{ getTokenLabel(row.center) }}</span>
                <span>{{ getTokenLabel(row.right) }}</span>
              </div>

              <!-- Title Preview -->
              <div
                class="my-2"
                :style="{
                  fontWeight: titleBold ? 'bold' : 'normal',
                  textAlign: titleAlign,
                  fontFamily: fontFamily,
                  fontSize: fontSize + 'pt'
                }"
              >
                {{ getTokenLabel(titleText) }}
              </div>

              <!-- Body placeholder — content swaps based on selectoption -->
              <div class="mt-2 p-2 text-muted" style="min-height:600px; font-size: 11px;">

  <!-- TABLE VIEW -->
  <div v-if="selectoption === 'table'" class="table-preview-container">
    <table class="clinical-table">
      <thead>
        <tr>
          <th v-for="(header, hi) in tableHeaders" :key="'th-' + hi"
            class="clinical-th"
            :class="'align-' + header.align">
            <span class="header-label">{{ header.label }}</span><br v-if="header.sub"/>
            <span v-if="header.sub" class="header-sub">{{ header.sub }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- Summary Row -->
        <tr class="summary-row">
          <td class="clinical-td text-start">{{ tableSummary.label }}</td>
          <td v-for="(header, hi) in tableHeaders.slice(1)" :key="'ts-td-' + hi" class="clinical-td text-center">
            {{ getCellValue(tableSummary, header.label) }}
          </td>
        </tr>
        <!-- Spacer row after summary -->
        <tr class="spacer-row"><td :colspan="tableHeaders.length"></td></tr>
        <!-- Sections -->
        <template v-for="(section, si) in computedTableData" :key="'ts-' + si">
          <!-- Section Header -->
          <tr class="section-header-row">
            <td :colspan="tableHeaders.length">
              {{ section.section }}
            </td>
          </tr>
          <!-- Term Rows -->
          <tr v-for="(row, ri) in section.rows" :key="'tr-' + si + '-' + ri" class="term-row">
            <td class="clinical-td term-name">{{ row.term }}</td>
            <td v-for="(header, hi) in tableHeaders.slice(1)" :key="'td-' + hi" class="clinical-td text-center">
              {{ getCellValue(row, header.label) }}
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>

  <!-- FIGURE VIEW (existing image) -->
    <div v-else-if="selectoption === 'figure'" style="background:white; padding:16px; height:400px; position: relative;">
      <div v-if="isGraphGenerating" class="chart-loader-overlay d-flex flex-column align-items-center justify-content-center">
        <i class="fa fa-spinner fa-spin fa-2x text-primary mb-2"></i>
        <span class="text-muted" style="font-size: 12px;">Graph is loading...</span>
      </div>
      <canvas ref="teaeChart" style="width:100%; height:100%;" :style="{ opacity: isGraphGenerating ? 0.2 : 1 }"></canvas>
    </div>
    <!-- <img src="../../assets/img/shellchart.png" alt="Shell Chart" style="width:100%;height:auto;display:block;" /> -->
  
  <!-- LISTING VIEW -->
      <div v-else-if="selectoption === 'listing'" class="listing-preview-container">
        <div class="clinical-listing">

          <!-- Header -->
          <div class="clinical-listing-header">
            <span v-for="(h, hi) in listingHeaders" :key="'lh-'+hi" :class="h.class">
              {{ h.label }}
            </span>
          </div>

          <!-- Summary Row -->
          <div class="clinical-listing-summary">
            <span class="col-term">{{ listSummary.label }}</span>
            <span v-for="(h, hi) in listingHeaders.slice(1)" :key="'lsum-'+hi" :class="h.class">
              {{ hi === 0 ? listSummary.group : (hi === 1 ? listSummary.subjects : '—') }}
            </span>
          </div>

          <!-- Sections -->
          <template v-for="(section, si) in listData" :key="'ls-' + si">
            <!-- Section Header -->
            <div class="clinical-listing-section">
              {{ section.section }}
            </div>

            <!-- Term Rows -->
            <div v-for="(row, ri) in section.rows" :key="'lr-' + si + '-' + ri"
              class="clinical-listing-term-group">

              <!-- First group row (shows term name) -->
              <div class="clinical-listing-row">
                <span class="col-term term-name">{{ row.term }}</span>
                <span v-for="(h, hi) in listingHeaders.slice(1)" :key="'lrow-'+hi" :class="h.class">
                  {{ hi === 0 ? row.groups[0].group : (hi === 1 ? row.groups[0].subjects : (hi === 2 ? row.groups[0].events : 'Mild (1)')) }}
                </span>
              </div>

              <!-- Remaining group rows -->
              <template v-if="!columnFieldNames || columnFieldNames.length === 0">
                <div v-for="(grp, gi) in row.groups.slice(1)" :key="'grp-' + gi"
                  class="clinical-listing-row">
                  <span class="col-term"></span>
                  <span class="col-group">{{ grp.group }}</span>
                  <span class="col-subjects">{{ grp.subjects }}</span>
                  <span class="col-events">{{ grp.events }}</span>
                  <span class="col-severity">{{ grp.severity }}</span>
                </div>
              </template>

              <!-- Total row -->
              <!-- <div class="clinical-listing-total">
                <span class="col-term"></span>
                <span class="col-group total-label">Total</span>
                <span class="col-subjects">{{ row.total.subjects }}</span>
                <span class="col-events">{{ row.total.events }}</span>
                <span class="col-severity"></span>
              </div> -->
            </div>
          </template>

          <!-- Footer note -->
          <div style="margin-top:10px; font-size:9px; color:#888; padding:0 10px;">
            TEAE = Treatment-Emergent Adverse Event. N = number of subjects in treatment group. n (%) = number and percentage of subjects with at least one event.
          </div>

        </div>
      </div>

              </div>

              <!-- Footer Preview -->
              <div
                v-for="(row, i) in footerRows"
                :key="'prev-footer-' + i"
                class="d-flex justify-content-between pt-1 mt-1"
                :class="{ 'border-top': footerBorderTop }"
              >
                <span>{{ getTokenLabel(row.left) }}</span>
                <span>{{ getTokenLabel(row.center) }}</span>
                <span>{{ getTokenLabel(row.right) }}</span>
              </div>

            </div>
          </div>
        </div>
         
        <!-- <div class=col-lg-1></div> -->
      </div>
    </div>
  </div>
</template>

<script src="./ShellEdit.js"></script>

<style scoped>
@import "../../assets/style.css";
@import "../../assets/formpage.css";

/* Section card — replaces the old nested bg-light cards */
.section-card {
  background: #f8f9fa;
  border: 1px solid #e4e4e4;
  border-radius: 4px;
  padding: 8px 10px;
  margin-bottom: 8px;
}
.section-title {
  font-size: 11px;
  font-weight: 700;
  color: #145faf;
  text-transform:none;
  letter-spacing: 0.3px;
  margin-bottom: 6px;
  justify-content: start;
}
.section-heading,
.section-subheading {
  display: flex;
  align-items: center;
  gap: 6px;
}
.section-heading {
  margin-bottom: 6px;
}
.section-heading .section-title {
  margin-bottom: 0;
}
.section-heading-icon {
  color: #0966d1;
  font-size: 12px;
  line-height: 1;
}

/* Small labels */
.form-label-sm {
  font-size: 11px;
  margin-bottom: 2px;
  display: block;
  color: #444;
}

/* Inputs / selects */
.form-control-sm,
.form-select-sm {
  font-size: 12px !important;
  padding: 3px 6px !important;
  height: 28px !important;
}

.form-select { border-radius: 0 !important; }
.form-select:focus { border-color: #145faf !important; box-shadow: none !important; }
.form-group { margin-bottom: 0 !important; }
.cursor-pointer { cursor: pointer; }

.preview-box { min-height: 900px; border: 1px solid #ddd; background: #fff;  overflow-x: auto; }
.versioncard { background-color: rgb(233, 246, 252); }
.border-left-blue { border-left: 6px solid #007bff !important; }
.left-scroll  { max-height: min(calc(100vh - 180px), 950px); overflow: hidden; }
.left-scroll:hover { overflow-y: auto; overflow-x: auto; }
.preview-scroll { height: min(calc(100vh - 180px), 950px); overflow: auto; }
.preview-scroll:hover { overflow-y: auto; overflow-x: auto; }

.btn-xs { padding: 2px 6px; font-size: 11px; line-height: 1; border-radius: 3px;  display: flex; align-items: center;justify-content: center;}
.btn-xs i { font-size: 10px; }

/* Force 12px on ALL elements inside the left scroll panel */
.left-scroll label,
.left-scroll span,
.left-scroll h4,
.left-scroll h5,
.left-scroll h6,
.left-scroll .fw-bold,
.left-scroll .badge,
.left-scroll small,
.left-scroll .small {
  font-size: 12px !important;
}
.left-scroll .form-control,
.left-scroll .form-select {
  font-size: 12px !important;
  padding: 3px 8px !important;
  height: 28px !important;
}
.left-scroll .form-select {
  padding-right: 24px !important;
}
.left-scroll .badge {
  font-size: 10px !important;
  padding: 2px 6px !important;
}
.left-scroll .versioncard {
  padding: 4px 8px !important;
}
 .preview-scroll h5{
font-size: 13px;
 }
 #header{
  font-size: 13px;
 }
 /* HEADER / TITLE / FOOTER section labels and their checkbox/radio labels */
.left-scroll .section-card > .d-flex .fw-bold,
.left-scroll .section-card > .mb-1 > .fw-bold {
  font-size: 11px !important;
   color: #145faf;
}
.left-scroll .section-card .small,
.left-scroll .section-card label.small {
  font-size: 11px !important;
   color: #145faf;
}

/* HEADER / TITLE / FOOTER section labels and their checkbox/radio labels */
.left-scroll .section-card > .d-flex .fw-bold,
.left-scroll .section-card > .mb-1 > .fw-bold {
  font-size: 11px !important;
  color: #145faf;
}
.left-scroll .section-card .small,
.left-scroll .section-card label.small {
  font-size: 11px !important;
  color: #145faf;
}
.select-wide{
  width: 200px;
}
input[type="checkbox"] {
    margin: 0;
    transform: translateY(-1px);
}
.unit{
  text-transform:lowercase;
}
.multiselect-theme {
  --ms-tag-bg: #145faf;
  --ms-tag-color: #fff;
  --ms-radius: 0;
  --ms-py: 0.4rem;
  --ms-option-font-size: 0.8rem;
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
}
.left-scroll::-webkit-scrollbar,
.preview-scroll::-webkit-scrollbar {
    width: 6px;
}

.left-scroll::-webkit-scrollbar-track,
.preview-scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.left-scroll::-webkit-scrollbar-thumb,
.preview-scroll::-webkit-scrollbar-thumb {
    background: #b7b7b7;
    border-radius: 10px;
}

.left-scroll::-webkit-scrollbar-thumb:hover,
.preview-scroll::-webkit-scrollbar-thumb:hover {
    background: #8a8a8a;
}
.left-scroll:hover,
.preview-scroll:hover {
  overflow-y: auto;
}

/* Scrollbar design */
.left-scroll::-webkit-scrollbar,
.preview-scroll::-webkit-scrollbar {
    width: 6px;
}

.left-scroll::-webkit-scrollbar-track,
.preview-scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.left-scroll::-webkit-scrollbar-thumb,
.preview-scroll::-webkit-scrollbar-thumb {
    background: #b7b7b7;
    border-radius: 10px;
}

.left-scroll::-webkit-scrollbar-thumb:hover,
.preview-scroll::-webkit-scrollbar-thumb:hover {
    background: #8a8a8a;
}

.badge-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 3px 10px;
  background: #EEF2FF;
  border: 1.5px solid #C7D2FE;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  color: #0242f0;
  cursor: pointer;
  letter-spacing: 0.01em;
  transition: background 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.badge-btn:hover {
  background: #E0E7FF;
  border-color: #A5B4FC;
  box-shadow: 0 2px 10px rgba(99,102,241,0.15);
}

.badge-study {
  background: #E8F6FF;
  border-color: #BEE6FF;
  color: #034E7B;
}

.badge-report {
  background: #fdfcc8;
  border-color: #f6ff73;
  color: #9c9201;
}

.badge-program {
  background: #F0FFF4;
  border-color: #CFF8DD;
  color: #0B6B3A;
}

.badge-study .badge-dot { background: #034E7B; }
.badge-report .badge-dot { background: #9c9201; }
.badge-program .badge-dot { background: #0B6B3A; }

.dot-wrap {
  position: relative;
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #045c77;
  position: relative;
  z-index: 1;
}
.save_btn{
    font-size: 13px; 
    text-align: center;
    background-color: #005c14 !important;
    border-color: #057201d7 !important;
    color: white !important;
    padding: 0.43rem 0.4rem;
    border-radius: 0.25rem;
    cursor: pointer;
    transition: background-color 0.3s
}

/* Clinical Table Design */
.table-preview-container {
  background: #fff;
  padding: 8px 12px;
  overflow-x: auto;
  /* border: 0px solid #eee; */
  max-width: 100%;
}

.clinical-table {
  width: 100%;
  border-collapse: collapse;
  font-family: 'Courier New', Courier, monospace;
  color: #000;
}

.clinical-table thead {
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
}

.clinical-th {
  padding: 6px 8px;
  font-size: 11px;
  font-weight: normal;
  color: #000;
  vertical-align: bottom;
  line-height: 1.3;
}

.clinical-th.align-left {
  text-align: left;
}
.clinical-th.align-center {
  text-align: center;
}
.clinical-th.align-right {
  text-align: right;
}

.header-label {
  font-weight: normal;
}

.header-sub {
  font-weight: normal;
  margin-top: 2px;
}

.clinical-td {
  padding: 4px 8px;
  font-size: 11px;
  font-weight: normal;
  color: #000;
  border: none;
  line-height: 1.3;
}

.clinical-td.text-start {
  text-align: left;
}
.clinical-td.text-center {
  text-align: center;
}
.clinical-td.text-end {
  text-align: right;
}

.summary-row td {
  padding-top: 6px;
  padding-bottom: 6px;
}

.spacer-row td {
  height: 14px;
  border: none;
}

.section-header-row td {
  padding-top: 12px;
  padding-bottom: 4px;
  font-size: 11px;
  font-weight: normal;
  text-transform: uppercase;
  color: #000;
  border: none;
  text-align: left;
}

.term-row td.term-name {
  padding-left: 20px; /* Indent preferred terms */
  text-align: left;
}

.clinical-table tbody {
  border-bottom: 1px solid #000;
}

/* Listing Styles */
.listing-preview-container {
  background: #fff;
  padding: 8px 12px;
  overflow-x: auto;
  max-width: 100%;
}

.clinical-listing {
  font-family: 'Courier New', Courier, monospace;
  font-size: 11px;
  color: #000;
  border-bottom: 1px solid #000;
}

.clinical-listing-header {
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  padding: 6px 8px;
  display: flex;
  gap: 8px;
  font-weight: normal;
  line-height: 1.3;
}

.clinical-listing-header span,
.clinical-listing-summary span,
.clinical-listing-row span,
.clinical-listing-total span {
  display: inline-block;
}

.col-term { width: 220px; text-align: left; }
.col-group { width: 90px; text-align: center; }
.col-subjects { width: 80px; text-align: center; }
.col-events { width: 80px; text-align: center; }
.col-severity { flex: 1; text-align: left; }

.clinical-listing-summary {
  padding: 6px 8px;
  display: flex;
  gap: 8px;
  font-weight: normal;
  line-height: 1.3;
}

.clinical-listing-section {
  padding: 12px 8px 4px 8px;
  font-weight: normal;
  text-transform: uppercase;
  color: #000;
  text-align: left;
}

.clinical-listing-term-group {
  padding: 2px 0;
}

.clinical-listing-row {
  padding: 3px 8px;
  display: flex;
  gap: 8px;
  line-height: 1.3;
}

.clinical-listing-row .term-name {
  padding-left: 20px;
}

.clinical-listing-total {
  padding: 3px 8px;
  display: flex;
  gap: 8px;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  margin-top: 2px;
  line-height: 1.3;
}

.total-label {
  font-weight: bold;
}

.clinical-listing-footer-note {
  margin-top: 15px;
  font-size: 10px;
  color: #555;
  padding: 8px 8px;
  border-top: 1px solid #000;
}
.chart-loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
</style>

